import styled, { css } from 'styled-components';
import { InputRadioProps } from './inputRadio.types';

export const InputRadio = styled.div`
  height: 28px;
  cursor: pointer;
`;

export const InputChecker = styled.div<{ selected: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme, selected }) => (selected ? theme.color.s1 : 'transparent')};
`;

export const Container = styled.div<{ disabled: InputRadioProps['disabled'] }>(
  ({ disabled }) => css`
    display: flex;
    align-items: center;

    user-select: none;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    opacity: ${disabled ? '0.5' : '1'};

    gap: 8px;
  `,
);

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Radio = styled.div`
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid grey;
`;

export const Label = styled.div(
  ({ theme: { color, font } }) => css`
    ${font.t2}
    color: ${color.ui2};
    padding: 5px;
  `,
);
